<template>
  <div class="main-layout__list">
    <div
      class="main-layout__item main-layout__item_head main-layout__item_hover main-layout__item_p12"
    >
      <p class="w-3 t-c foz-23">#</p>
      <div class="w-5"></div>
      <p class="w-10">{{ $t("listsHeader.service") }}</p>

      <div class="main-layout__item-actions">{{ $t("listsHeader.actions") }}</div>
    </div>

    <div
      class="main-layout__item main-layout__item_hover"
      v-for="(service, index) in services"
      :key="service.id"
      :class="{
        delete: service.deletion_tag,
        disabled: !service.is_active,
      }"
    >
      <p class="w-3 t-c">{{ index + 1 }}</p>
      <div class="w-5 main-layout__item-image">
        <img :src="service.icon" alt="main-layout-image"/>
      </div>
      <p class="w-10">{{ service.title }}</p>
      <!-- <p class="w-10">
        <span>€</span>
        {{ service.price | round }}
      </p>-->
      <div class="main-layout__item-actions">
        <div
          v-if="$guard('write', 'Services')"
          class="list-button"
          @click="openService(service.id)"
        >
          <svg class="main-layout__item-icon">
            <use xlink:href="/images/svg/symbols.svg#svg-user-message" />
          </svg>
        </div>
        <div
          v-if="role !== 'partner-admin'"
          class="materials-list-button"
          @click="openDelete(service)"
        >
          <svg class="main-layout__item-icon">
            <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
          </svg>
        </div>
        <div>
          <router-link
            :to="{
              name: `ServiceMaterial`,
              params: { id: service.id, serviceTitle: service.title },
            }"
            class="services-list__material-link"
          >
            <svg
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 406.72 406.72"
              fill="var(--bg-color-green)"
              xml:space="preserve"
              class="main-layout__item-icon"
            >
              <g>
                <g>
                  <g>
                    <polygon
                      points="203.253,352.853 203.253,352.853 45.92,230.507 11.36,257.387 203.36,406.72 395.36,257.387 360.587,230.4
                                            "
                    />
                    <polygon
                      points="203.36,298.667 360.48,176.533 395.36,149.333 203.36,0 11.36,149.333 46.133,176.32"
                    />
                  </g>
                </g>
              </g>
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
            </svg>
          </router-link>
        </div>
        <!-- <div class="list-button">
          <svg
            @click="$emit('openServiceSchedule', service.id)"
            class="main-layout__item-icon"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.9499 18.9999H2.05C1.45 18.9999 1 18.5499 1 17.9499V2.05C1 1.45 1.45 1 2.05 1H17.8749C18.4749 1 18.9249 1.45 18.9249 2.05V17.8749C18.9999 18.5499 18.5499 18.9999 17.9499 18.9999Z"
              stroke="#9BCD82"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.99997 6.99997H1V2.05C1 1.45 1.45 1 2.05 1H6.99997V6.99997Z"
              stroke="#9BCD82"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.9999 1H6.99994V6.99997H12.9999V1Z"
              stroke="#9BCD82"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M19 6.99997H13V1H17.95C18.55 1 19 1.45 19 2.05V6.99997Z"
              stroke="#9BCD82"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.99997 6.99976H1V12.9997H6.99997V6.99976Z"
              stroke="#9BCD82"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.9999 6.99976H6.99994V12.9997H12.9999V6.99976Z"
              stroke="#9BCD82"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M19 6.99976H13V12.9997H19V6.99976Z"
              stroke="#9BCD82"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.99997 19H2.05C1.45 19 1 18.55 1 17.95V13H6.99997V19Z"
              stroke="#9BCD82"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.9999 13H6.99994V19H12.9999V13Z"
              stroke="#9BCD82"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17.95 19H13V13H19V17.95C19 18.55 18.55 19 17.95 19Z"
              stroke="#9BCD82"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.79999 8.80005L11.2 11.2"
              stroke="#9BCD82"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.2 8.80005L8.79999 11.2"
              stroke="#9BCD82"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2.79999 14.7998L5.19998 17.1998"
              stroke="#9BCD82"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5.19998 14.7998L2.79999 17.1998"
              stroke="#9BCD82"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14.7999 8.80005L17.1999 11.2"
              stroke="#9BCD82"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17.1999 8.80005L14.7999 11.2"
              stroke="#9BCD82"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>-->

        <delete-request
          v-if="$guard('delete', 'Administrators') && service.deletion_tag"
          :item="service"
          :type="'services'"
          @save="getServices"
          @remove="openDeleteAdapter"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import deleteRequest from '@/components/controls/deleteRequest'

export default {
    name: 'services-list',
    components: {
        deleteRequest,
    },
    data() {
        return {
            type: 'services',
            role: window.$role,
        }
    },
    computed: {
        ...mapGetters({
            services: 'servicesFullData',
        }),
    },
    methods: {
        ...mapMutations({
            toggleServiceModal: 'setServiceModal',
            toggleDeleteModal: 'setDeleteModal',
            setDeleteId: 'setDeleteId',
            setEdit: 'setEdit',
            setDeletionStatus: 'setServicesDeletionStatus',
        }),
        ...mapActions({
            getServices: 'getServices',
            toggleServiceActivity: 'toggleServiceActivity',
            requestForDeleteService: 'requestForDeleteService',
        }),
        openService(id) {
            this.$store.dispatch('getServiceData', id).then(() => {
                this.$Progress.finish()
            })

            this.setEdit(true)
            this.toggleServiceModal()
        },
        openDeleteAdapter(id) {
            this.openDelete({ id })
        },
        openDelete({ id, deletion_tag }) {
            this.setDeleteId(id)
            this.setDeletionStatus(deletion_tag && !this.$guard('write', 'Services'))

            this.toggleDeleteModal()
        },
        async toggleServiceActive(service) {
            await this.toggleServiceActivity({
                id: service.id,
                is_active: service.is_active,
            })
        },
        decline(id) {
            this.requestForDeleteService(id)
        },
    },
}
</script>

<style lang="scss" scoped>
// @import "src/assets/sass/main";
// body .disabled {
//   background-color: #e4dcdc;

//   &:hover {
//     background-color: #e4dcdc !important;
//   }
// }

// .custom-checkbox {
//   input {
//     display: none;
//   }

//   input:checked + label:before {
//     position: absolute;
//     content: "";
//     left: 2px;
//     right: 2px;
//     top: 0;
//     bottom: 2px;
//     background-image: url(https://image.flaticon.com/icons/svg/60/60516.svg);
//     background-position: center;
//     z-index: 9;
//     background-size: cover;
//   }

//   label {
//     border: 2px solid #61422d;
//     cursor: pointer;
//     padding: 7px;
//     display: block;
//     position: relative;
//   }
// }

// .services-list {
//   width: 100%;
//   margin-top: 16px;
//   margin-bottom: 50px;
//   border-radius: 8px;
//   background-color: #ffffff;
//   height: calc(100vh - 250px);
//   box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
//   overflow-y: scroll;
//   position: relative;

//   &__isActive {
//     margin-left: 2%;
//     display: flex;
//     align-items: center;
//   }

//   &__active {
//     width: 15%;
//     margin-left: 5%;
//   }

//   &__item {
//     display: flex;
//     align-items: center;
//     transition: 0.5s;
//     padding: 2.5px;
//     font-size: 14px;
//     color: #4d4d4d;

//     &:hover {
//       background-color: rgba(113, 189, 74, 0.15);
//     }

//     &_head {
//       font-weight: bold;
//       padding-right: 10px;

//       .services-list__cost {
//         width: 20.5%;
//       }
//     }
//   }

//   &__index {
//     width: 64px;
//     text-align: center;
//     font-size: 30px;
//     margin: 0;
//     font-family: $fontLight !important;
//     color: #e0e0e0;
//   }

//   &__title {
//     width: 25%;
//     padding-left: 20px;
//     font-family: $fontBold;

//     &_bold {
//       font-family: $fontBold;
//     }
//   }

//   &__cost {
//     width: 20%;

//     span {
//       font-size: 14px;
//     }

//     &_bold {
//       font-family: $fontBold;
//     }
//   }

//   &__actions {
//     display: flex;
//     align-items: center;

//     &_bold {
//       font-family: $fontBold;
//     }
//   }

//   &__icon {
//     display: flex;
//     align-items: center;

//     img {
//       width: 30px;
//       height: 30px;
//       object-fit: cover;
//       margin-right: 10px;
//       display: inline-block;
//     }
//   }

//   &__color {
//     display: flex;
//     align-items: center;
//     padding: 0 10px;

//     label {
//       width: 20px;
//       height: 20px;
//       border-radius: 4px;
//       display: block;
//       margin-right: 8px;
//     }
//   }

//   &__material-link {
//     text-underline-position: under;
//     text-decoration: underline;
//   }

//   &__image {
//     width: 50px;
//     text-align: center;
//     padding: 0 10px;

//     img {
//       width: 30px;
//       object-fit: cover;
//       height: 30px;
//     }

//     &_bold {
//       font-family: $fontBold;
//     }
//   }

//   svg {
//     width: 25px;
//     height: 25px;
//     margin-right: 6px;
//     cursor: pointer;
//   }
// }
</style>
